import React from "react";
import Filter1Outlined from '@mui/icons-material/FilterAlt';

import './Filter.css'

interface FilterProps {
  onFilter: (value: string) => void;
  accountType?: string;
}

interface FilterState {
  status: string;
  showDropdown: boolean;
}

class Filter extends React.Component<FilterProps, FilterState> {
  constructor(props: FilterProps) {
    super(props);

    this.state = {
      status: "",
      showDropdown: false
    };
  }

  toggleDropdown = () => {
    this.setState({
      showDropdown: !this.state.showDropdown
    });
  };

  handleChange = (value: string) => {
    this.setState(
      {
        status: value,
        showDropdown: false
      },
      () => {
        this.props.onFilter(value); // Call parent API
      }
    );
  };

  getdropdownValue = (accountType: string = "1") => {
    return accountType == "1" ? (
      <select
        value={this.state.status}
        onChange={(e) => this.handleChange(e.target.value)}
      >
        <option value="">All Status</option>
        <option value="subscriptionPending">
          Subscription Pending
        </option>
        <option value="subscriptionCompleted">
          Subscription Completed
        </option>
        <option value="personaPending">
          ID Verification Pending
        </option>
        <option value="personaCompleted">
          ID Verification Completed
        </option>
        <option value="form8821Signed">
          Form 8821 Signed
        </option>
        <option value="form8821Submitted">
          Form 8821 Submitted
        </option>
        <option value="form8821Approved">
          Form 8821 Approved
        </option>
        <option value="financialsPending">
          Financials Pending
        </option>
        <option value="financialsCompleted">
          Financials Completed
        </option>
        <option value="form433APending">
          Form 433-A Pending
        </option>
        <option value="form433ACompleted">
          Form 433-A Completed
        </option>
        <option value="form433DApproved">
          Form 433-D Approved
        </option>
        <option value="form433DSubmitted">
          Form 433-D Submitted
        </option>
      </select>) :
      (
        <select
          value={this.state.status}
          onChange={(e) => this.handleChange(e.target.value)}
        >
          <option value="">All Status</option>
          <option value="personaPending">
            ID Verification Pending
          </option>
          <option value="personaCompleted">
            ID Verification Completed
          </option>
          <option value="form8821Approved">
            Form 8821 Approved
          </option>
          <option value="form8821Submitted">
            Form 8821 Submitted
          </option>
        </select>)
  };

  render() {
    return (
      <div className="dt-filter-wrapper">
        {/* Filter Icon */}
        <Filter1Outlined
          className="dt-filter-icon"
          onClick={this.toggleDropdown}
        />

        {/* Dropdown */}
        {this.state.showDropdown && (
          <div className="dt-filter-dropdown">
            {this.getdropdownValue(this.props.accountType)}
          </div>
        )}
      </div>
    );
  }
}

export default Filter;